<div class="auth-container">
  <div class="auth-layout">
    <!-- Left Side - Reset Password Form -->
    <div class="auth-left">
      <!-- VHI Logo - Top Left -->
      <div class="auth-logo-header">
        <img src="../../../assets/img/vhi_logo.png" alt="Company Logo" />
      </div>
      <div class="auth-form-container">
        <div class="auth-form">
          
          <!-- Email Request State -->
          <div *ngIf="!isCodeSend">
            <h2 class="reset-title">Reset Password</h2>
            
            <form (ngSubmit)="resetPass()" (keydown.enter)="resetPass()">
              <div class="form-group mb-4">
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  #email="ngModel" 
                  [(ngModel)]="user.email" 
                  class="form-control"
                  placeholder="Enter your email"
                  autocomplete="email">
              </div>

              <div class="d-grid gap-2 mb-4">
                <button 
                  type="submit" 
                  class="btn btn-primary btn-lg" 
                  [disabled]="loading">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" *ngIf="loading"></span>
                  Send Code
                </button>
              </div>
            </form>

            <div class="text-center mt-4">
              <a href="" [routerLink]="['/auth/signIn']" class="text-muted text-decoration-none">
                Back to sign in
              </a>
            </div>

            <p class="text-center text-muted mt-5">
              New to Talonic? <a href="" [routerLink]="['/auth/signUp']" class="text-primary">Create an account</a>
            </p>
          </div>

          <!-- Code Submission State -->
          <div *ngIf="isCodeSend">
            <h2 class="reset-title">Enter Reset Code</h2>
            
            <form (ngSubmit)="forgotPasswordSubmit()" (keydown.enter)="forgotPasswordSubmit()">
              <div class="form-group mb-4">
                <input 
                  type="text" 
                  id="code" 
                  name="code" 
                  #code="ngModel" 
                  [(ngModel)]="user.code" 
                  class="form-control"
                  placeholder="Enter verification code"
                  autocomplete="one-time-code">
              </div>

              <div class="form-group mb-4">
                <div class="input-group">
                  <input 
                    [type]="user.showPassword ? 'text' : 'password'" 
                    id="password" 
                    name="password" 
                    #password="ngModel" 
                    [(ngModel)]="user.password" 
                    class="form-control"
                    placeholder="Enter new password"
                    autocomplete="new-password">
                  <button 
                    type="button" 
                    class="btn btn-outline-secondary" 
                    (click)="user.showPassword = !user.showPassword">
                    <i class="bi" [ngClass]="{'bi-eye-fill': !user.showPassword, 'bi-eye-slash-fill': user.showPassword}"></i>
                  </button>
                </div>
              </div>

              <div class="form-group mb-4">
                <div class="input-group">
                  <input 
                    [type]="user.showConfirmPass ? 'text' : 'password'" 
                    id="confirmPassword" 
                    name="confirmPassword" 
                    #confirmPassword="ngModel" 
                    [(ngModel)]="user.confirmPassword" 
                    class="form-control"
                    placeholder="Confirm new password"
                    autocomplete="new-password">
                  <button 
                    type="button" 
                    class="btn btn-outline-secondary" 
                    (click)="user.showConfirmPass = !user.showConfirmPass">
                    <i class="bi" [ngClass]="{'bi-eye-fill': !user.showConfirmPass, 'bi-eye-slash-fill': user.showConfirmPass}"></i>
                  </button>
                </div>
              </div>

              <div class="d-grid gap-2 mb-4">
                <button 
                  type="submit" 
                  class="btn btn-primary btn-lg" 
                  [disabled]="loading">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" *ngIf="loading"></span>
                  Reset Password
                </button>
              </div>
            </form>

            <div class="text-center mt-4">
              <button 
                type="button" 
                (click)="resetPass()" 
                class="btn btn-resend"
                [disabled]="loading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" *ngIf="loading"></span>
                Resend Code
              </button>
            </div>

            <p class="text-center text-muted mt-5">
              Remember your password? <a href="" [routerLink]="['/auth/signIn']" class="text-primary">Sign in</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side - Gradient Background with Slides -->
    <div class="auth-right">
      <div class="gradient-background">
        <div class="slides-container">
          <div class="slide active">
            <img src="../../../assets/img/backgrounds/sign-in-slide-1.svg" alt="Reset Password" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>